import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import locationService from './locationService';
import provisionService, { LocationOption } from './provisionService';

const queryKeys = {
  getAll: () => ['PROVISIONER:GET:Locations.WithTerminals'],
  getBranding: () => ['POS:GET:Location.Branding'],
};

const useQuery_GetAllLocationsWithTerminals = (...args: Parameters<typeof provisionService.location.getAll>) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('location.errors.getAll') });
  return useQuery<LocationOption[], ServiceError>({
    queryKey: queryKeys.getAll(),
    queryFn: async () => {
      try {
        return await provisionService.location.getAll(...args);
      } catch (e) {
        throw parseError(e);
      }
    },
    // only make requests when required arguments are fulfilled
    enabled: args.length > 0 && Boolean(args[0].orgId),
  });
};

const useQuery_GetLocationBranding = () => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('location.errors.getBranding') });
  return useQuery({
    queryKey: queryKeys.getBranding(),
    queryFn: async () => {
      try {
        return await locationService.getBranding({});
      } catch (e) {
        throw parseError(e);
      }
    },
  });
};

const useLocation = {
  query: {
    getAll: useQuery_GetAllLocationsWithTerminals,
    getBranding: useQuery_GetLocationBranding,
  }
};

export { useLocation };

